import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propArrayShape, propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import HtmlLink from '../../../Ui/Common/HtmlLink';
import Image from '../../../Ui/Common/Image';
import SlideSearchItemCheckbox from '../../../Ui/SlideSearch/Input/SlideSearchItemCheckbox';
import Hover from '../../../Ui/System/Hover';
const SlideSearchItem = (props) => {
    const { checked, item, items, onChange, onClickSlideSearchLink, unit, uuid } = props;
    const { slide } = item;
    const page = useMemo(() => item.pageId
        ? item.slide.pages.find((v) => v.id === item.pageId)
        : item.slide.pages[0], [item]);
    const link = useMemo(() => {
        const uniqueSlideItems = [
            ...new Map(items.map((v) => [v.slideId, v])).values(),
        ];
        const params = uniqueSlideItems.map((v) => ({
            pageId: page && v.slideId === page.slideId ? page.id : v.pageId,
            slideId: v.slideId,
        }));
        const query = params.length > 0 ? `?view=${JSON.stringify(params)}` : '';
        return `/proffit_search/slide/${item.slideId}${query}`;
    }, [item, items, page]);
    const image = useMemo(() => (page || {}).image || '', [page]);
    return (_jsx(Hover, { children: _jsxs("div", Object.assign({ className: 'slide_search_list_item' }, { children: [_jsxs(HtmlLink, Object.assign({ className: 'item_inner', "data-history_result_id": item.historyResultId || '', onClick: onClickSlideSearchLink, to: link }, { children: [_jsxs("div", Object.assign({ className: 'item_thumbnail_box' }, { children: [_jsx("div", Object.assign({ className: clsx('item_thumbnail', !!page.isVerticalImage && 'is-vertical-image') }, { children: _jsx(Image, { alt: '', className: 'item_image', isObjectFitContain: true, src: image, useImage: true }) })), _jsx("div", { className: 'item_full-overlay' })] })), _jsx("h4", Object.assign({ className: 'item_title' }, { children: slide.title }))] })), _jsx(SlideSearchItemCheckbox, { checked: checked, className: 'item_checkbox_wrap', item: item, onChange: onChange, unit: unit, uuid: uuid })] })) }));
};
SlideSearchItem.propTypes = {
    checked: propBool().isRequired,
    item: propShape().isRequired,
    items: propArrayShape(),
    onChange: propFunc().isRequired,
    onClickSlideSearchLink: propFunc(),
    unit: propShape().isRequired,
    uuid: propStr().isRequired,
};
SlideSearchItem.defaultProps = {
    items: [],
    onClickSlideSearchLink: null,
};
export default SlideSearchItem;
